
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payments",
      function () {
        return require("private-next-pages/payments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payments"])
      });
    }
  